import React, { FC, useCallback, useMemo, useRef, useState } from 'react';
import { useHistory } from 'react-router';

import { Button } from 'devextreme-react/button';
import DataGrid, {
  Column,
  ColumnChooser,
  FilterPanel,
  FilterRow,
  GroupPanel,
  HeaderFilter,
  Lookup,
  Pager,
  Paging,
  StateStoring,
} from 'devextreme-react/data-grid';
import 'devextreme-react/text-area';

import { maskedPhone } from 'utils/masked-phone';

import { AppCard, AppLayoutTop } from '../../../../components/appComponents';
import ClaimsProvider from '../../../../components/claimsBlock';
import { male } from '../../../../types/books';
import $createStore from '../../../../utils/create-store-instance';
import DeleteModal from './components/Delete';

const Employee: FC = () => {
  const history = useHistory();

  const storePost: any = useMemo(() => {
    return $createStore('/v1/post', 'id');
  }, []);

  const EmployeeDataStore: any = useMemo(() => {
    return $createStore('/v1/Employee', 'id');
  }, []);

  const [visibleDelete, setVisibleDelete] = useState<boolean>(false);
  const [openIdDelete, setOpenIdDelete] = useState<number | null>(null);

  const refGrid = useRef<DataGrid | null>(null);

  const refresh = useCallback(() => refGrid.current?.instance.refresh(), []);

  return (
    <div>
      <AppLayoutTop title="Сотрудники">
        <ClaimsProvider claimsBlock={['CanEditEmployees']}>
          <Button
            width={120}
            text="Создать"
            type="default"
            //onClick={() => refGrid.current?.instance.addRow()}
            onClick={() => history.push('/employee/add')}
          />
        </ClaimsProvider>
      </AppLayoutTop>

      {visibleDelete && (
        <DeleteModal visible={visibleDelete} changeVisible={setVisibleDelete} id={openIdDelete} refresh={refresh} />
      )}

      <AppCard>
        <DataGrid
          dataSource={EmployeeDataStore}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          ref={refGrid}
          remoteOperations={true}
          onRowUpdating={(e) => (e.newData = { ...e.oldData, ...e.newData })}
          onInitNewRow={(e) =>
            (e.data = {
              comment: '',
              surname: '',
              isResident: false,
              isOfficiallyEmployed: false,
              phone: '',
              email: '',
              name: '',
              middleName: '',
            })
          }
          allowColumnResizing
          columnResizingMode="nextColumn"
          columnMinWidth={50}
          allowColumnReordering
        >
          <StateStoring enabled={true} type="localStorage" storageKey="employee" />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible />
          <GroupPanel visible={true} />
          <ColumnChooser enabled={true} />

          <Column dataField="surname" caption="Фамилия" sortOrder="asc" />
          <Column dataField="name" caption="Имя" />

          <Column dataField="middleName" caption="Отчество" />
          <Column dataField="sex" caption="Пол">
            <Lookup dataSource={male} valueExpr="id" displayExpr="name" />
          </Column>
          <Column dataField="phone" caption="Телефон" cellRender={({ data }) => maskedPhone(data.phone)} />
          <Column dataField="email" caption="email" />
          <Column dataField="isResident" caption="Резидент" />
          <Column dataField="isOfficiallyEmployed" caption="Официально трудоустроен" />
          <Column dataField="postId" caption="Должность">
            <Lookup dataSource={storePost} valueExpr="id" displayExpr="name" />
          </Column>

          <Column
            dataField=""
            caption=""
            width={150}
            cellRender={(data) => (
              <ClaimsProvider claimsBlock={['CanEditEmployees']}>
                <div>
                  <Button
                    icon="edit"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      history.push(`/employee/detail/${data.key}`);
                    }}
                  />
                  <Button
                    icon="trash"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      setOpenIdDelete(data.key);
                      setVisibleDelete(true);
                    }}
                  />
                </div>
              </ClaimsProvider>
            )}
          />
          <Column dataField="comment" caption="Комментарий" width={100} visible={false} />
          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default Employee;
